import ICampaignTds from "@/interfaces/ICampaignTds";
import IMultiSelectItem from "@/interfaces/selects/IMultiSelectItem";
import ISelectItemDefault from "@/interfaces/selects/ISelectItemDefault";
import cloneObject from "@/libs/cloneObject";
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

import CampaignTdsForm from '@/components/Subscriptions/Campaign/CampaignForm/CampaignTdsForm/CampaignTdsForm.vue';
import {Action, Getter} from "vuex-class";

@Component({
    name: 'CampaignTdsDetail',
    components: {
        CampaignTdsForm
    }
})
export default class CampaignTdsDetail extends Vue {
    @Prop(String) private modalId!: string;
    @Prop(String) private modalTitle!: string;
    @Prop({type: Boolean, default: false}) private hideFooter!: boolean;
    @Prop(Boolean) private showModal!: boolean;

    @Prop(Object) private campaignTdsData!: ICampaignTds;
    @Prop(Number) private campaignTdsIndex!: number;
    @Prop(Array) private landings!: ISelectItemDefault[];
    @Prop(Array) private countries!: IMultiSelectItem[];
    @Prop(Array) private osForTds!: IMultiSelectItem[];

    // Begin Vuex Logic for Campaign TDS
    @Action private subscriptionsCampaignTdsChange!: (form: ICampaignTds) => string;
    @Action private subscriptionsCampaignTdsRemove!: (id: number) => string;
    // End Vuex Logic for Campaign TDS

    private show: boolean | null = null;

    @Watch('showModal')
    private toggleModal(): void {
        this.show = this.showModal;
    }

    private get headerTitle(): string {
        return 'Campaign TDS';
    }

    private closeModal() {
        this.$emit('closeModalTds')
    }

    private valueFromObjectToStr(field: string, sourceData: any) {
        return sourceData[field].map((el: any) => el.value);
    }

    private async saveTds() {
        const prefix: string = '/api/subscription';

        const form = cloneObject(this.campaignTdsData);
        form.landing = `${prefix}/subscription_landings/${form.landing.value}`;

        form.countrySet = this.valueFromObjectToStr('countrySet', form);
        form.osSet = this.valueFromObjectToStr('osSet', form);
        form.modelSet = this.valueFromObjectToStr('modelSet', form);

        delete form.createdAt;
        delete form.updatedAt;

        try {
            const changeStatus = await this.subscriptionsCampaignTdsChange(form);
            if (changeStatus === 'changed') {
                this.closeModal();

                this.$emit('updateTdsItem');

                this.$notify({
                    group: 'notice',
                    title: `${this.modalTitle}`,
                    text: 'Changed Successfully',
                    type: 'success'
                });
            }
        } catch (error) {
            throw new Error(error)
        }
    }

    private async deleteTds() {
        try {
            const removeStatus = await this.subscriptionsCampaignTdsRemove(Number(this.campaignTdsData.id));

            if (removeStatus === 'deleted') {
                this.closeModal();

                this.$emit('removeTdsItem', this.campaignTdsIndex)

                this.$notify({
                    group: 'notice',
                    title: 'Campaign TDS',
                    text: 'Deleted Successfully',
                    type: 'success'
                });
            }
        } catch (error) {
            throw new Error(error);
        }
    }
}
